import { IDetailsRepasseDto, TotalDetalheRepasseDto } from '../../../../global/dataTransferObjects/repasses';
import { IPagedRepasseResult } from '../../../../global/generics';

export interface IPageState {
  loading: boolean;
  detalhes: IPagedRepasseResult<IDetailsRepasseDto>;
  totalRepasses: TotalDetalheRepasseDto;
  zeroState: boolean;
}

export enum ActionTypes {
  UPDATE_LOADING_STATUS = 'UPDATE_LOADING_STATUS',
  GET_DETALHES_REPASSES = 'GET_DETALHES_REPASSES',
  ZERO_STATE_STATUS = 'ZERO_STATE_STATUS',
}

export interface IAction {
  type: ActionTypes;
  payload?: any;
}
